import * as React from 'react';
import Grid from '@mui/material/Grid';
import { Divider, Typography, styled } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useTranslation } from 'react-i18next';
import CustomModal from '../Common/CustomModal';
import { slimScrollbarStyles } from '../../utils/styles';

interface IDeleteNoteConfirmationProps {
  maskedRecording: string;
  rowRecording: string;
  isOpen: boolean;
  closeModal: () => void;
}

const DeleteButton = styled(LoadingButton)(() => ({
  borderRadius: 15,
  background: `linear-gradient(175.46deg, #FF9A9A -9.81%, #FF5858 96.32%)`,
  color: 'var(--Accent-White, #FFF) !important',
  '&:hover': {
    background: `linear-gradient(175.46deg, #FF9A9A -9.81%, #FF5858 96.32%)`,
  },
}));

const RecordingOverview = ({
  maskedRecording,
  rowRecording,
  isOpen,
  closeModal,
}: IDeleteNoteConfirmationProps) => {
  const { t } = useTranslation();

  return (
    <CustomModal isOpen={isOpen} xs={11.5}>
      <Grid
        maxHeight="95vh"
        minHeight={600}
        p={4}
        flexDirection="column"
        gap="24px"
        overflow="auto"
        sx={{
          ...slimScrollbarStyles,
        }}
      >
        <Grid item display="flex" alignItems="center" justifyContent="space-between" width="100%">
          <Typography variant="title1Bold" color="primary">
            {t('notes.recordingOverview.title')}
          </Typography>
          <img
            src="/assets/icons/close-circle-large.svg"
            alt="close-icon"
            onClick={closeModal}
            role="presentation"
            style={{
              cursor: 'pointer',
              maxHeight: '22px',
            }}
          />
        </Grid>
        <Grid item>
          <Divider sx={{ backgroundColor: '#FFDDC8', height: 1, my: '24px' }} />
        </Grid>

        <Grid item>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Typography variant="h6" color="primary" pb={2}>
                {t('notes.recordingOverview.subTitle1')}
              </Typography>
              <Typography variant="title3Regular" color="primary">
                {maskedRecording}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="h6" color="primary" pb={2}>
                {t('notes.recordingOverview.subTitle2')}
              </Typography>
              <Typography variant="title3Regular" color="primary">
                {rowRecording}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </CustomModal>
  );
};

export default RecordingOverview;
